import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts/index'

/**
 * 加载该脚本之后，设置节点的 visible 将会不影响持久化的值
 */
export interface editTextScript {
  proxyVisible: boolean
}

export const getScript = (node: qc.Node, addScriptIfScriptNotExist = true): editTextScript | undefined => {
  const config: editTextScript = node.getScript(scripts.editText.name)
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    return node.addScript(scripts.editText.name) as editTextScript
  }
}

export const removeScript = (node: qc.Node): void => {
  const config: editTextScript = node.getScript(scripts.editText.name)
  if (config) {
    node.removeScript(config)
  }
}
